<template>
  <div class="fcbr100-control-box">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="模块" prop="module">
        <el-checkbox-group v-model="form.module">
          <el-checkbox label="cwaMod">cwaMod</el-checkbox>
          <el-checkbox label="bioMod">bioMod</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="命令" prop="command">
        <el-select v-model="form.command" placeholder="请选择命令" style="width: 100%">
          <el-option label="开启" value="0"></el-option>
          <el-option label="关闭" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: right">
      <el-button @click="closeHandler">取消</el-button>
      <el-button :loading="saveLoading" type="primary" @click="onSubmit">发送</el-button>
    </div>
  </div>
</template>

<script>
import { fcbrStartServer } from '@/api/remoteControl';

export default {
  props: {
    sn: {
      type: String
    }
  },
  data() {
    return {
      form: {
        command: '',
        module: []
      },
      rules: {
        command: [{ required: true, message: '请选择发送的命令', trigger: 'change' }],
        module: [{ required: true, message: '请选择模块', trigger: 'change' }]
      },
      saveLoading: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveLoading = true;
          let params = {
            sn: [this.sn],
            control: this.form.command,
            mods: this.form.module
          };
          fcbrStartServer(params)
            .then(res => {
              if (res.code === 200) {
                this.$message.success('发送成功');
                this.$emit('sendSuccess');
              }
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      });
    },
    closeHandler() {
      this.$emit('closeFCBRDialog');
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
// .BM3001-control-box {
//   text-align: center;
// }
</style>
